// extracted by mini-css-extract-plugin
export default {"flexContainer":"AboutPage_flexContainer__cJh7T"};